
























import { Component, Vue } from "vue-property-decorator";
import FloatingInner from "@/layouts/FloatingInner.vue";
import CButton from "@/basics/buttons/CButton.vue";

@Component({
  components: {
    FloatingInner,
    CButton
  }
})
export default class Error extends Vue {}
